/*
 * @Author: aisi
 * @Date: 2019-11-25 11:13:06
 * @LastEditTime : 2020-01-07 18:40:38
 * @LastEditors  : Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /vue/wei/src/api/class/analyse.js
 */
import { get } from "../http";

export default {
  //获取单次测评结束分析
  getAnalyse: params => {
    return get(
      `/index.php?r=mobileapp/specialPlanAnalysis/getSingleAnalysis&planId=${params.planID}&examLogId=${params.examLogId}`
    );
  },
  // 命题质量分析
  getTestOverallSituation: params => {
    return get(
      `/index.php?r=mobileapp/examAnalysis/testOverallSituation&examinationid=${params.examinationid}&testid=${params.testid}&schoolid=${params.schoolid}&campusid=${params.campusid}`
    );
  },
  // 等级总体分析
  getRankAnalysis: params => {
    return get(
      `/index.php?r=mobileapp/examAnalysis/rankAnalysis&examinationid=${params.examinationid}&testid=${params.testid}&schoolid=${params.schoolid}&campusid=${params.campusid}`
    );
  },
  // 中考科目A+对比
  getAdvancedStudentRank: params => {
    return get(
      `/index.php?r=mobileapp/examAnalysis/advancedStudentRank&examinationid=${params.examinationid}&testid=${params.testid}&schoolid=${params.schoolid}&campusid=${params.campusid}&type=${params.type}`
    );
  },
  // 关注群体分析
  getFocusGroupAnalysis: params => {
    return get(
      `/index.php?r=mobileapp/examAnalysis/focusGroupAnalysis&examinationid=${params.examinationid}&testid=${params.testid}&schoolid=${params.schoolid}&campusid=${params.campusid}&type=${params.type}`
    );
  },
  // 历次考试全A+稳定性分析
  getStabilityAnalysis: params => {
    return get(
      `/index.php?r=mobileapp/examAnalysis/stabilityAnalysis&examinationid=${params.examinationid}&testid=${params.testid}&schoolid=${params.schoolid}&campusid=${params.campusid}&type=${params.type}`
    );
  },
  // 总成绩分析概况
  getExaminationAnalysis: params => {
    return get(
      `/index.php?r=mobileapp/examAnalysis/examinationAnalysis&examinationid=${params.examinationid}&testid=${params.testid}&schoolid=${params.schoolid}&campusid=${params.campusid}`
    );
  },
  // 总成绩平均分对比
  getAverageScoreContrast: params => {
    return get(
      `/index.php?r=mobileapp/examAnalysis/averageScoreContrast&examinationid=${params.examinationid}&testid=${params.testid}&schoolid=${params.schoolid}&campusid=${params.campusid}`
    );
  },
  // 总成绩分数段对比
  getFractionalSegment: params => {
    return get(
      `/index.php?r=mobileapp/examAnalysis/fractionalSegment&examinationid=${params.examinationid}&testid=${params.testid}&schoolid=${params.schoolid}&campusid=${params.campusid}`
    );
  },
  // 总成绩人数、占比
  getRankStudentCount: params => {
    return get(
      `/index.php?r=mobileapp/examAnalysis/rankStudentCount&examinationid=${params.examinationid}&testid=${params.testid}&schoolid=${params.schoolid}&campusid=${params.campusid}&type=${params.type}`
    );
  },
  // 总成绩竞争力对比图
  getCompetitivePower: params => {
    return get(
      `/index.php?r=mobileapp/examAnalysis/competitivePower&examinationid=${params.examinationid}&testid=${params.testid}&schoolid=${params.schoolid}&campusid=${params.campusid}`
    );
  },
  // 语文概况
  getSingleTestAnalysis: params => {
    return get(
      `/index.php?r=mobileapp/examAnalysis/singleTestAnalysis&examinationid=${params.examinationid}&testid=${params.testid}&schoolid=${params.schoolid}&campusid=${params.campusid}`
    );
  }
};
